exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/meghneel/work/baba_frontend/src/app/forgot-password/reset-password/reset-password.component.css
// module id = ../../../../../src/app/forgot-password/reset-password/reset-password.component.css
// module chunks = main